import { HealthcareProviderLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { addressFormatter } from '@dreryk/react-common';
import { SecondaryText, Select, StyledFlex } from '@dreryk/react-components';

type HealthcareProviderLocationSelectItemProps = {
   readonly location: HealthcareProviderLocation;
};

export const HealthcareProviderLocationSelectItem = (props: HealthcareProviderLocationSelectItemProps): JSX.Element => {
   return (
      <Select.Item<HealthcareProviderLocation>
         item={props.location}
         label={
            <StyledFlex direction={'column'}>
               <span>{props.location.name}</span>
               <SecondaryText
                  testId={'healthcareProviderLocationAddress'}
                  text={<>{addressFormatter(props.location.address)}</>}
                  compact
               />
            </StyledFlex>
         }
         testId={props.location.locationIdentifier.locationId}
      />
   );
};
